import { CardMedia } from "@mui/material";

function CarouselCard({ image }) {
  return (
    <CardMedia
      component="img"
      image={image}
      alt="image"
      sx={{
        height: "250px",
        width: "213px",
        objectFit: "fill",
      }}
    />
  );
}

export default CarouselCard;
